import { Component, EventEmitter, Input, isDevMode, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';

import { NavLink } from '@classes/nav-link';
import { SubscriptionBaseComponent } from '@components/subscription-base/subscription-base.component';
import { environment } from '@environments/environment';
import { AppConfigService } from '@services/app-config.service';
import { AuthService } from '@services/auth.service';
import { NavService } from '@services/nav.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-main-nav',
    templateUrl: './main-nav.component.html',
    styleUrls: ['./main-nav.component.scss'],
    standalone: false
})
export class MainNavComponent implements OnInit, OnDestroy {
    @Output() sidenavClose = new EventEmitter<void>();

    navLinks: NavLink[];
    isMaintenance: boolean;
    isLocalTranslations: boolean = isDevMode();
    appVersion: string;

    private unsubscribeAll = new Subject<void>();

    constructor(
        private authSrv: AuthService,
        private configSrv: AppConfigService,
        private navSrv: NavService
    ) {
    }

    ngOnInit() {
        this.appVersion = environment.version;
        this.isMaintenance = this.configSrv.isMaintenance;

        this.initSubscriptions();
    }

    ngOnDestroy(): void {
        this.unsubscribeAll.next();
        this.unsubscribeAll.complete();
    }

    onCloseSidenav(): void {
        this.sidenavClose.emit();
    }

    private initSubscriptions() {
        this.authSrv.authUser$
            .pipe(takeUntil(this.unsubscribeAll))
            .subscribe((user) => {
                this.navLinks = this.navSrv.getNavLinks();
            });
    }
}
